import * as React from "react";

const DefaultCard: React.FC = () => {
    return (
        <svg width="800px" height="800px" viewBox="0 -3 24 24"  fill="none" 
        xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17 11H19C19.5523 11 20 10.5523 20 10C20 9.4477 19.5523 9 19 9H17C16.4477 9 16 9.4477 16 10C16 10.5523 16.4477 11 17 11zM8 11H14C14.5523 11 15 10.5523 15 10C15 9.4477 14.5523 9 14 9H8C7.44772 9 7 9.4477 7 10C7 10.5523 7.44772 11 8 11zM24 5.01176C23.9407 5.00402 23.88 5 23.8182 5H0.181818C0.119988 5 0.0592673 5.00402 0 5.01176V3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V5.01176zM24 6.98824V15C24 16.6569 22.6569 18 21 18H3C1.34315 18 0 16.6569 0 15V6.98824C0.0592673 6.99598 0.119988 7 0.181818 7H23.8182C23.88 7 23.9407 6.99598 24 6.98824z" fill="#758CA3"/></svg>
    );
};

export default React.memo(DefaultCard);
